import { createStore, applyMiddleware, combineReducers } from "redux";
import logger from "redux-logger";
import { routes, selections } from "./reducers";

applyMiddleware(logger);
let reducers = combineReducers({ routes, selections });

export default () => {
  let store = createStore(reducers, {});
  return store;
};



// WEBPACK FOOTER //
// ./src/redux/store.js